import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeScreen from './HomeScreen';
import './App.css';

import Stock from './Stock';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/stock/:symbol" element={<Stock />} />
      </Routes>
    </Router>
  );
};

export default App;
